import {
  ActivatedRouteSnapshot,
  ResolveFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { inject } from '@angular/core';
import { NavigationPipe } from '../pipes/navigation/navigation.pipe';
import { Path } from '../constants/paths.constant';
import { tap } from 'rxjs';
import { ReceivedRFPFormItemResponse } from '../models/received-rfp';
import { ReceivedRfpService } from '../services/received-rfp/received-rfp.service';

const navigateToReceivedRfpBoard = (
  router: Router,
  navigationPipe: NavigationPipe,
  userType: 'buyer' | 'contractor'
): void => {
  router.navigate([
    navigationPipe.transform(`${userType}/${Path.RECEIVED_RFP.RECEIVED_RFP}`),
  ]);
};

export const receivedRfpDetailsResolver: ResolveFn<
  ReceivedRFPFormItemResponse | undefined
> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const navigationPipe = new NavigationPipe();
  const router = inject(Router);
  const rfpId = route.params['rfpId'];
  const userType = 'contractor';
  const getDetails = inject(ReceivedRfpService).getReceivedRFPById(rfpId);

  if (rfpId) {
    return getDetails.pipe(
      tap(({ rfp, contractor_rfp }) => {
        if (!rfp || !contractor_rfp) {
          navigateToReceivedRfpBoard(router, navigationPipe, userType);
          return;
        }
      })
    );
  } else {
    return undefined;
  }
};
